import _calendario from '@src/js/vue/mixins/calendario.js';
import { _api, URLparams } from '@src/js/msp/api.js';
import { getConfig } from '@shared/config/runtime.js';
function getEndpoint() { return getConfig().api_base_url + "/api/v2/attivita.php"; }

export const configAssociazione = {
    allenamento: {
        id: "allenamento",
        current: "all'allenamento",
        target: "un'attività",
        targets: "attività",
        key: "allenamento_id",
        keyTarget: "attivita_id",
        warningTarget: "Attività già associata a un altro allenamento.<br>Vuoi sostituirlo?",
        functions: {
            "current": "getAllenamento",
            "target": "loadAttivita",
        },
    },
    attivita: {
        id: "attivita",
        current: "all'attività",
        target: "un allenamento",
        targets: "allenamenti",
        key: "attivita_id",
        keyTarget: "allenamento_id",
        warningTarget: "Allenamento già associato a un'altra attività.<br>Vuoi sostituirla?",
        functions: {
            "current": "getAttivita",
            "target": "loadAllenamenti",
        },
    },
};

export function getAllenamento(id, token) {

    let data = {
        info: true,
        allenamento_id: id,
    }
    let params = URLparams(data);

    let url = `${getEndpoint()}?${params}`;

    return new Promise((resolve,reject)=>{
        _api(url, 'get', null, token)
            .then(
                (result)=>{
                    if (result.success) {
                        resolve(result.data);
                    } else {
                        resolve(null);
                    }
                },
                (error)=>{
                    reject(error);
                }
            )
    });
}

export function getAttivita(id, token) {

    let data = {
        info: true,
        attivita_id: id,
    }
    let params = URLparams(data);

    let url = `${getEndpoint()}?${params}`;

    return new Promise((resolve,reject)=>{
        _api(url, 'get', null, token)
            .then(
                (result)=>{
                    if (result.success) {
                        resolve(result.data);
                    } else {
                        resolve(null);
                    }
                },
                (error)=>{
                    reject(error);
                }
            )
    });
}
export function loadAttivita(utente_id, sport_id, date_from, date_to, token, sort_dir = 'desc') {

    let data = {
        list: true,
        sport_id: sport_id,
        da: date_from,
        a: date_to,
        atleta_id: utente_id,
        sort_dir: sort_dir,
    }
    let params = URLparams(data);
    let url = `${getEndpoint()}?${params}`;

    return new Promise((resolve,reject)=>{
        _api(url, "GET",null,token)
            .then((result)=>{
                if (result.success) {
                    resolve(result.data);
                } else {
                    resolve([]);
                }
            })
            .catch((error)=>{
                reject(error);
            });
    });
}

export function loadAllenamenti(utente_id, sport_id, date_from, date_to, token, sort_dir = 'desc') {

    let data = {
        allenamenti: true,
        sport_id: sport_id,
        da: date_from,
        a: date_to,
        atleta_id: utente_id,
        sort_dir: sort_dir,
    }
    let params = URLparams(data);

    let url = `${getEndpoint()}?${params}`;

    return new Promise((resolve,reject)=>{
        _api(url, 'get', null, token)
            .then(
                (result)=>{
                    if (result.success) {
                        resolve(result.data);
                    } else {
                        resolve([]);
                    }
                },
                (error)=>{
                    reject(error);
                }
            )
    });
}

export function makeRange (date, more = false) {
    const prevWeek = _calendario.addDays(date, -7);
    const dateTo = more ? _calendario.addDays(date, 7) : date;
    return {
        da: _calendario.getMonday(prevWeek),
        a: _calendario.getSunday(dateTo),
    };
}

export function makeItemsFromAllenamenti (data) {
    if (!data) return [];

    return data.map((el)=>{
        return {
            id: el.id,
            date: el.data,
            title: el.titolo,
            associato: el.attivita_id,
        }
    });

}


export function byDateAsc(a, b) {
    return byDate(a,b,false);
}

export function byDateDesc(a, b) {
    return byDate(a,b,true);
}

export function byDate(a,b,reverse) {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        
        if (dateA < dateB) return reverse ? 1 : -1;
        if (dateA > dateB) return reverse ? -1 : 1;
        return 0;
}


export function makeItemsFromAttivita (data) {
    if (!data) return [];

    return data.map((el)=>{

        const titoloAllenamento = el.titoloAllenamento || el.sport.toLowerCase();

        return {
            id: el.id,
            date: el.dataCompetenza,
            title: `${el.stringDistanza} in ${el.stringDurata} | ${titoloAllenamento}`,
            associato: el.idAllenamentoAssociato,
        }
    });

}
